import UserRegister from './register';

export default class UserRegisterDesktop extends UserRegister {
}
